var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.groups),function(group){return _c('div',{key:group.id},[_c('GroupDataRow',{attrs:{"group":group,"groupData":_vm.groupData(group),"isShowNamePath":"","projectId":_vm.projectId}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }